import { css } from '@emotion/css'

import { spacing } from '../../../styles'

const popupTipIconSize = 16

const styles = {
  wrapper: css({
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: 0,
    position: 'relative',
  }),

  tooltip: css({
    display: 'flex',
    marginLeft: spacing.extraSmall,

    '> div': {
      maxWidth: 150,
      width: 'max-content',
    },
  }),

  popupTip: css({
    display: 'flex',
    position: 'absolute',
    right: -popupTipIconSize - spacing.small,
    top: '50%',
    transform: 'translateY(-50%)',
  }),

  popupTipIcon: css({
    padding: '4px',
  }),
}

export default styles
